<template>
  <v-card
    outlined
    class="rounded-lg"
    :color="accentColor"
    :style="{ 'border-color': accentColor }"
  >
    <v-container
      v-if="display != 'home' && display != 'historical'"
      class="pa-2 px-6"
    >
      <v-row d-flex>
        <v-col
          v-if="notification.is_silenced && !notification.cleared"
          cols="auto"
        >
          <span style="color: white; text-align: center">
            <v-icon
              dark
              size="small"
              style="vertical-align: middle"
              class="mr-1"
              >mdi-bell-sleep</v-icon
            >
            <span
              style="
                font-family: Inter;
                font-size: 14px;
                font-weight: 400;
                vertical-align: middle;
              "
              >{{ silencedUntilText }}</span
            >
          </span>
        </v-col>
        <v-col
          v-else-if="!notification.archived && !$vuetify.breakpoint.xs"
          cols="auto"
        >
          <span style="color: white; text-align: center">
            <v-icon
              dark
              size="small"
              style="vertical-align: middle"
              class="mr-1"
              >mdi-timer-outline</v-icon
            >
            <span
              style="
                font-family: Inter;
                font-size: 14px;
                font-weight: 400;
                vertical-align: middle;
              "
              ><notification-time-since :notification="notification"
            /></span>
          </span>
        </v-col>
        <v-col
          v-if="!(notification.is_silenced && !notification.cleared)"
          cols="auto"
        >
          <div style="color: white; text-align: center">
            <v-icon
              dark
              size="small"
              style="vertical-align: middle"
              class="mr-1"
              >mdi-calendar</v-icon
            >
            <span
              style="
                font-family: Inter;
                font-size: 14px;
                font-weight: 400;
                vertical-align: middle;
              "
              >{{ toDateHumanFormat(notification?.time) }}</span
            >
          </div>
        </v-col>
        <v-col
          v-if="!(notification.is_silenced && !notification.cleared)"
          cols="auto"
        >
          <div style="color: white; text-align: center">
            <v-icon
              dark
              size="small"
              style="vertical-align: middle"
              class="mr-1"
              >mdi-clock-outline</v-icon
            >
            <span
              style="
                font-family: Inter;
                font-size: 14px;
                font-weight: 400;
                vertical-align: middle;
              "
              >{{ toTimeHumanFormat(notification?.time) }}</span
            >
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="px-0">
          <v-btn small icon color="white" @click="goToSource()">
            <v-icon dark size="small" style="vertical-align: middle"
              >mdi-cube-outline</v-icon
            >
          </v-btn>
        </v-col>
        <v-col v-if="display != 'alert'" cols="auto" class="px-0">
          <v-btn small icon color="white" @click="silenceAlert(notification)">
            <v-icon dark size="small" style="vertical-align: middle"
              >mdi-bell-sleep</v-icon
            >
          </v-btn>
        </v-col>
        <v-col
          v-if="display != 'alert' && notification.appearance != 'information'"
          cols="auto"
          class="px-0"
        >
          <v-btn small icon color="white" @click="goToNotification">
            <v-icon dark size="small" style="vertical-align: middle"
              >mdi-open-in-new</v-icon
            >
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card
      class="rounded-lg"
      :style="{
        'border-color': accentColor,
        'box-shadow': shadow,
        color: accentColor,
      }"
    >
      <v-container class="pa-6">
        <v-row
          d-flex
          :class="{
            'flex-column':
              (display === 'historical' || display === 'alert') &&
              $vuetify.breakpoint.xs,
          }"
        >
          <v-col
            :cols="
              (display === 'historical' || display === 'alert') &&
              $vuetify.breakpoint.xs
                ? '12'
                : 'auto'
            "
            align-self="center"
            :class="
              (display === 'historical' || display === 'alert') &&
              $vuetify.breakpoint.xs
                ? 'pb-2 d-flex justify-start'
                : ''
            "
          >
            <span
              :style="{ 'background-color': accentColor }"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 8px;
                border-radius: 8px;
                font-size: 20px;
                font-weight: 600;
              "
            >
              <v-icon large color="white">{{ icon }}</v-icon>
            </span>
          </v-col>
          <v-row
            v-if="
              (display === 'historical' || display === 'alert') &&
              $vuetify.breakpoint.xs
            "
            no-gutters
            class="mb-2 mx-0 px-3 align-center"
            style="width: 100%"
          >
            <v-col cols="9" class="pr-2 pl-0">
              <div class="pl-0">
                <div v-if="scope == 'Ingestor'" class="mb-1">
                  <span
                    style="
                      font-family: Inter;
                      text-transform: uppercase;
                      font-size: 10px;
                    "
                  >
                    {{ ingestorName }}
                  </span>
                </div>
                <div v-else class="mb-1">
                  <span
                    style="
                      font-family: Inter;
                      text-transform: uppercase;
                      font-size: 10px;
                      cursor: pointer;
                    "
                    @click="toChain()"
                    >{{ chainName }}</span
                  >
                  <span
                    v-if="scope == 'Node'"
                    style="
                      font-family: Inter;
                      text-transform: uppercase;
                      padding-left: 4px;
                      padding-right: 4px;
                      font-size: 10px;
                    "
                    >/</span
                  >
                  <span
                    v-if="scope == 'Node'"
                    style="
                      font-family: Inter;
                      text-transform: uppercase;
                      font-size: 10px;
                      cursor: pointer;
                    "
                    @click="toNode()"
                    >{{ nodeName }}</span
                  >
                </div>
                <div style="font-family: Inter; font-size: 14px">
                  {{ notification?.text }}
                </div>
              </div>
            </v-col>
            <v-col
              cols="3"
              class="d-flex justify-end align-self-center pl-0 pr-0"
            >
              <v-btn
                v-if="display === 'historical'"
                icon
                :color="accentColor"
                @click="goToNotification()"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn
                v-else-if="display === 'alert'"
                icon
                :color="accentColor"
                @click="showDetails = !showDetails"
              >
                <v-icon v-if="showDetails">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-col
            v-else
            :cols="
              (display === 'historical' || display === 'alert') &&
              $vuetify.breakpoint.xs
                ? '12'
                : 'auto'
            "
            align-self="center"
            class="pr-0"
            :style="
              (display === 'historical' || display === 'alert') &&
              $vuetify.breakpoint.xs
                ? 'max-width: 100%'
                : 'max-width: calc(100% - 140px)'
            "
          >
            <v-container class="py-0">
              <v-row v-if="scope == 'Ingestor'" align="center">
                <v-col cols="auto" class="pa-0" style="cursor: pointer">
                  <div>
                    <span
                      style="
                        font-family: Inter;
                        text-transform: uppercase;
                        font-size: 10px;
                      "
                      >{{ ingestorName }}</span
                    >
                  </div>
                </v-col>
              </v-row>
              <v-row v-else align="center">
                <v-col
                  cols="auto"
                  class="pa-0"
                  style="cursor: pointer"
                  @click="toChain()"
                >
                  <div>
                    <span
                      style="
                        font-family: Inter;
                        text-transform: uppercase;
                        font-size: 10px;
                      "
                      >{{ chainName }}</span
                    >
                  </div>
                </v-col>
                <v-col v-if="scope == 'Node'" cols="auto" class="pa-0">
                  <div>
                    <span
                      style="
                        font-family: Inter;
                        text-transform: uppercase;
                        padding-left: 4px;
                        padding-right: 4px;
                        font-size: 10px;
                      "
                    >
                      /
                    </span>
                  </div>
                </v-col>
                <v-col
                  v-if="scope == 'Node'"
                  cols="auto"
                  class="pa-0"
                  style="cursor: pointer"
                  @click="toNode()"
                >
                  <div>
                    <span
                      style="
                        font-family: Inter;
                        text-transform: uppercase;
                        font-size: 10px;
                      "
                      >{{ nodeName }}</span
                    >
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pa-0">
                  <div style="font-family: Inter; font-size: 14px">
                    {{ notification?.text }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-spacer
            v-if="
              !(
                (display === 'historical' || display === 'alert') &&
                $vuetify.breakpoint.xs
              )
            "
          ></v-spacer>
          <v-col
            v-if="
              !(
                (display === 'historical' || display === 'alert') &&
                $vuetify.breakpoint.xs
              )
            "
            cols="auto"
            align-self="center"
          >
            <v-btn
              v-if="display == 'home'"
              icon
              :color="accentColor"
              @click="goToSource()"
            >
              <v-icon large style="margin">mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
              v-else-if="display == 'historical'"
              icon
              :color="accentColor"
              @click="goToNotification()"
            >
              <v-icon large style="margin">mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
              v-else
              icon
              :color="accentColor"
              @click="showDetails = !showDetails"
            >
              <v-icon v-if="showDetails" large style="margin"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else large>mdi-chevron-down</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-col v-if="showDetails" class="pa-6 pb-7 pt-9 mt-n2 details-section">
      <v-row v-for="detail in unclearedDetails" :key="detail.field">
        <v-col cols="auto" class="py-1"
          ><span
            style="font-family: Inter; font-size: 0.875rem; font-weight: 600"
            >{{ detail.field }}</span
          ></v-col
        >
        <v-spacer></v-spacer>
        <v-col cols="auto" class="py-1"
          ><span
            style="font-family: Inter; font-size: 0.875rem; font-weight: 400"
            >{{ detail.value }}</span
          ></v-col
        >
      </v-row>
    </v-col>
  </v-card>
</template>

<script>
import NotificationTimeSince from './NotificationTimeSince.vue';

import { mapGetters } from 'vuex';

import { encodeQuery } from '../../utils/queryParams';
import { formatMetricValue } from '../../services/metricService';

export default {
  components: {
    NotificationTimeSince,
  },
  props: {
    notification: {
      type: Object,
      default() {
        return {};
      },
    },
    display: {
      type: String,
      default: '',
    },
    show: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    showDetails: false,
  }),
  computed: {
    ...mapGetters([
      'allIngestorIds',
      'allChainIds',
      'allNodeIds',
      'allIngestors',
      'allNodes',
      'allChains',
    ]),
    node() {
      if (this.scope == 'Node') {
        let search = this.allNodes.filter((node) => {
          return node.id == this.sourceId;
        });
        if (search.length > 0) {
          return search[0];
        }
      }
      return null;
    },
    chain() {
      if (this.scope === 'Chain') {
        let search = this.$store.state.chain.chains.filter((chain) => {
          return chain.id === this.sourceId;
        });
        if (search.length > 0) {
          return search[0];
        }
      } else if (this.node != null) {
        let search = this.$store.state.chain.chains.filter((chain) => {
          return chain.id === this.node.chain_id;
        });
        if (search.length > 0) {
          return search[0];
        }
      }
      return null;
    },
    alertId() {
      return this.notification?.id;
    },
    sourceId() {
      return this.notification?.source;
    },
    scope() {
      return this.notification?.scope.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    ingestorName() {
      return 'Ingestor 1';
    },
    chainName() {
      if (this.chain) {
        return this.chain.name;
      }
      return null;
    },
    nodeName() {
      return this.node?.name;
    },
    metricName() {
      return this.notification?.metric;
    },
    metricModule() {
      return this.metricName?.split('/')[0];
    },
    metricMetric() {
      return this.metricName?.split('/')[1];
    },
    url() {
      return this.notification?.url;
    },
    metricValue() {
      return this.$store.state.metrics.metric[
        `${this.node.id}/${this.metricName}`
      ];
    },
    alertText() {
      return this.notification?.text;
    },
    alertCreated() {
      return this.notification.time
        ? this.toDateHumanFormat(this.notification.time) +
            ' ' +
            this.toTimeHumanFormat(this.notification.time)
        : null;
    },
    alertUpdated() {
      return this.notification.updated
        ? this.toDateHumanFormat(this.notification.updated) +
            ' ' +
            this.toTimeHumanFormat(this.notification.updated)
        : null;
    },
    alertCleared() {
      return this.notification.cleared
        ? this.toDateHumanFormat(this.notification.cleared) +
            ' ' +
            this.toTimeHumanFormat(this.notification.cleared)
        : null;
    },
    latestValue() {
      return formatMetricValue(
        this.metricModule,
        this.metricMetric,
        this.notification?.latest_value
      );
    },
    errorValue() {
      return formatMetricValue(
        this.metricModule,
        this.metricMetric,
        this.notification?.error_value
      );
    },
    criteria() {
      return formatMetricValue(
        this.metricModule,
        this.metricMetric,
        this.notification?.criteria
      );
    },
    metricCurrent() {
      return formatMetricValue(
        this.metricModule,
        this.metricMetric,
        this.metricValue
      );
    },
    detailsSection() {
      return this.display != 'home';
    },
    unclearedDetails() {
      return this.details.filter(
        (detail) => !(detail.field == 'Alert Cleared' && !detail.value)
      );
    },
    details() {
      if (this.scope === 'Chain') {
        return [
          {
            field: 'Alert ID',
            value: this.alertId,
          },
          {
            field: 'Scope',
            value: this.scope,
          },
          {
            field: 'Chain',
            value: this.chainName,
          },
          {
            field: 'Metric',
            value: this.metricName,
          },
          {
            field: 'Alert',
            value: this.alertText,
          },
          {
            field: 'Alert Created',
            value: this.alertCreated,
          },
          {
            field: 'Alert Cleared',
            value: this.alertCleared,
          },
        ];
      } else if (this.scope === 'Node') {
        if (this.notification.appearance == 'information') {
          return [
            {
              field: 'Alert ID',
              value: this.alertId,
            },
            {
              field: 'Scope',
              value: this.scope,
            },
            {
              field: 'Chain',
              value: this.chainName,
            },
            {
              field: 'Node',
              value: this.nodeName,
            },
            {
              field: 'Metric',
              value: this.metricName,
            },
            {
              field: 'URL',
              value: this.url,
            },
            {
              field: 'Alert',
              value: this.alertText,
            },
            {
              field: 'Previous Value',
              value: this.criteria,
            },
            {
              field: 'Current Value',
              value: this.errorValue,
            },
            {
              field: 'Notification Created',
              value: this.alertCreated,
            },
          ];
        } else {
          return [
            {
              field: 'Alert ID',
              value: this.alertId,
            },
            {
              field: 'Scope',
              value: this.scope,
            },
            {
              field: 'Chain',
              value: this.chainName,
            },
            {
              field: 'Node',
              value: this.nodeName,
            },
            {
              field: 'Metric',
              value: this.metricName,
            },
            {
              field: 'URL',
              value: this.url,
            },
            {
              field: 'Alert',
              value: this.alertText,
            },
            {
              field: 'Criteria',
              value: this.criteria,
            },
            {
              field: 'Value Recorded',
              value: this.errorValue,
            },
            {
              field: 'Alert Created',
              value: this.alertCreated,
            },
            {
              field: 'Current Value',
              value: this.metricCurrent,
            },
            {
              field: 'Alert Cleared',
              value: this.alertCleared,
            },
          ];
        }
      } else if (this.scope === 'Ingestor') {
        return [
          {
            field: 'Alert ID',
            value: this.alertId,
          },
          {
            field: 'Scope',
            value: this.scope,
          },
          {
            field: 'Ingestor',
            value: this.ingestorName,
          },
          {
            field: 'Alert',
            value: this.alertText,
          },
          {
            field: 'Alert Created',
            value: this.alertCreated,
          },
          {
            field: 'Alert Cleared',
            value: this.alertCleared,
          },
        ];
      } else {
        return [];
      }
    },
    backgroundColor() {
      if (this.notification?.is_silenced && !this.notification?.cleared) {
        return 'hsl(0, 0%, 94%)';
      } else if (this.notification?.archived) {
        return 'hsl(0, 0%, 94%)';
      } else if (this.notification?.appearance == 'success') {
        return 'hsl(120, 67%, 94%)';
      } else if (this.notification?.appearance == 'information') {
        let previousValue = parseInt(this.notification.criteria);
        let currentValue = parseInt(this.notification.error_value);
        if (currentValue < previousValue) {
          return 'hsl(80, 87%, 94%)';
        } else if (currentValue > previousValue) {
          return 'hsl(20, 87%, 94%)';
        } else return 'hsl(220, 87%, 94%)';
      } else if (this.notification?.appearance == 'warning') {
        return 'hsl(40, 87%, 94%)';
      } else if (this.notification?.appearance == 'error') {
        return 'hsl(0, 87%, 94%)';
      } else return 'hsl(0, 0%, 94%)';
    },
    accentColor() {
      if (this.notification?.is_silenced && !this.notification?.cleared) {
        return 'hsl(0, 0%, 0%)';
      } else if (this.notification?.archived) {
        return 'hsl(0, 0%, 59%)';
      } else if (this.notification?.appearance == 'success') {
        return 'hsl(120, 67%, 39%)';
      } else if (this.notification?.appearance == 'information') {
        let previousValue = parseInt(this.notification.criteria);
        let currentValue = parseInt(this.notification.error_value);
        if (currentValue < previousValue) {
          return 'hsl(80, 87%, 39%)';
        } else if (currentValue > previousValue) {
          return 'hsl(20, 87%, 59%)';
        } else return 'hsl(220, 87%, 49%)';
      } else if (this.notification?.appearance == 'warning') {
        return 'hsl(40, 87%, 49%)';
      } else if (this.notification?.appearance == 'error') {
        return 'hsl(0, 87%, 59%)';
      } else return 'hsl(0, 0%, 59%)';
    },
    shadow() {
      if (this.notification?.is_silenced && !this.notification?.cleared) {
        return '0px 0px 6px hsla(0, 0%, 0%, 0.75)';
      } else if (this.notification?.archived) {
        return '0px 0px 6px hsla(0, 0%, 59%, 0.75)';
      } else if (this.notification?.appearance == 'success') {
        return '0px 0px 6px hsla(120, 87%, 39%, 0.75)';
      } else if (this.notification?.appearance == 'information') {
        let previousValue = parseInt(this.notification.criteria);
        let currentValue = parseInt(this.notification.error_value);
        if (currentValue < previousValue) {
          return '0px 0px 6px hsla(80, 87%, 49%, 0.75)';
        } else if (currentValue > previousValue) {
          return '0px 0px 6px hsla(20, 87%, 49%, 0.75)';
        } else return '0px 0px 6px hsla(220, 87%, 49%, 0.75)';
      } else if (this.notification?.appearance == 'warning') {
        return '0px 0px 6px hsla(39, 87%, 49%, 0.75)';
      } else if (this.notification?.appearance == 'error') {
        return '0px 0px 6px hsla(0, 87%, 59%, 0.75)';
      } else return '0px 0px 6px hsla(0, 0%, 59%, 0.75)';
    },
    icon() {
      if (this.notification?.is_silenced && !this.notification?.cleared) {
        return 'mdi-bell-sleep';
      } else if (this.notification?.appearance == 'success') {
        return 'mdi-check-circle-outline';
      } else if (this.notification?.appearance == 'information') {
        let previousValue = parseInt(this.notification.criteria);
        let currentValue = parseInt(this.notification.error_value);
        if (currentValue < previousValue) {
          return 'mdi-arrow-up-bold-circle-outline';
        } else if (currentValue > previousValue) {
          return 'mdi-arrow-down-bold-circle-outline';
        } else return 'mdi-bell-outline';
      } else if (this.notification?.appearance == 'warning') {
        return 'mdi-alert-outline';
      } else if (this.notification?.appearance == 'error') {
        return 'mdi-alert-circle-outline';
      } else return 'mdi-bell-outline';
    },
    silencedInfo() {
      if (this.scope === 'Node') {
        // Check node alerts
        let nodes = this.allNodes;
        let node = nodes.find((n) => n.id === this.sourceId);

        if (node && node.alerts) {
          let matchingAlert = node.alerts.find(
            (alert) =>
              alert.source_id === this.sourceId &&
              alert.metric === this.metricName &&
              alert.url === this.url
          );

          if (matchingAlert) {
            return {
              isSilenced: matchingAlert.is_silenced,
              silencedUntil: matchingAlert.silenced_until,
            };
          }
        }
      } else if (this.scope === 'Chain') {
        // Check chain alerts
        let chains = this.$store.state.chain.chains;
        let chain = chains.find((c) => c.id === this.sourceId);

        if (chain && chain.alerts) {
          let matchingAlert = chain.alerts.find(
            (alert) =>
              alert.source_id === this.sourceId &&
              alert.metric === this.metricName &&
              alert.url === this.url
          );

          if (matchingAlert) {
            return {
              isSilenced: matchingAlert.is_silenced,
              silencedUntil: matchingAlert.silenced_until,
            };
          }
        }
      }

      // Default or fallback
      return {
        isSilenced: this.notification.is_silenced,
        silencedUntil: this.notification.silenced_until,
      };
    },

    silencedUntilText() {
      if (!this.silencedInfo.isSilenced) {
        return 'Not Silenced';
      }
      if (!this.silencedInfo.silencedUntil) {
        return 'Silenced';
      }
      return `Silenced until ${this.toTimeHumanFormat(this.silencedInfo.silencedUntil)}`;
    },
  },
  methods: {
    toChain() {
      if (this.notification.scope == 'node') {
        this.$router.push(`/chain/${this.node.chain_id}`).catch(() => {});
      } else if (this.notification.scope == 'chain') {
        this.$router.push(`/chain/${this.notification.source}`).catch(() => {});
      }
    },
    toNode() {
      if (this.notification.scope == 'node') {
        this.$router
          .push(`/node/${this.node.chain_id}/${this.node.id}`)
          .catch(() => {});
      }
    },
    goToSource() {
      if (this.notification.scope == 'node') {
        this.$router
          .push(`/node/${this.node.chain_id}/${this.node.id}`)
          .catch(() => {});
      } else if (this.notification.scope == 'chain') {
        this.$router.push(`/chain/${this.notification.source}`).catch(() => {});
      }
    },
    goToNotification() {
      let queryParams = {
        metric: this.notification.metric,
        source: this.notification.source,
        url: this.notification.url,
      };
      this.$router.push(`/alert?${encodeQuery(queryParams)}`);
    },
    silenceAlert() {
      console.log(
        `silence alert button clicked: ${JSON.stringify(this.notification)}`
      );
      let alertSourceId = {
        metric: this.notification?.metric,
        source: this.notification?.source,
        url: this.notification?.url,
      };
      this.$emit('editAlert', alertSourceId);
    },
  },
};
</script>

<style>
.details-section {
  background-color: hsl(0, 0%, 98%);
  color: rgba(0, 0, 0, 0.87);
}
</style>
